export const STATUS_CODE = {
  SUCCESS: 0,
  SEND_CODE_IM_FAILED: 500, // 发送验im证码错误
  NOT_AUTH: 501, // 请求token校验失败
  NO_PHONE: 502, // 未绑定手机号
  SEND_CODE_MESSAGE_FAILED: 503, // 发送短信验证码失败
  GET_UID_FAILED: 504, // 通过bigoid获取uid失败
  CHECK_CODE_FAILED: 505, // 校验验证码不通过
  ERR_BIND_PHONE_FAILED: 521, // 绑定验证码失败
};
